import { ReactElement, useCallback } from "react";
import { localize } from "client_legacy/ndaw/culture";
import {
	generateTrackingId,
	getNumericEnumValues,
	hasFlag
} from "client/Misc/utils";
import { UserLicense } from "client/Api/FeaturePackages/featurePackageManagement";
import { UserLicenseList } from "../Licensing/UserLicenseManagement/UserLicenseList";
import { UserLicenseCard } from "../Licensing/UserLicenseManagement/UserLicenseCard";
import { IValueInputAttachable } from "client/Forms/attachable";
import { EditableUserFields } from "client/Api/UserManagement/userManagement";
import { UserLicenseDescription } from "../Licensing/UserLicenseManagement/UserLicenseDescription";

export type UserLicensesTabProps = {
	editUserFieldsMode: EditableUserFields;
	attachable: IValueInputAttachable<UserLicense>;
};

export const UserLicensesTab = (props: UserLicensesTabProps): ReactElement => {
	const {
		editUserFieldsMode,
		attachable
	} = props;

	const changeHandler = useCallback(
		(value: UserLicense): void => {
			attachable.reducer
				.setValue(value);

			attachable.validation
				.triggerInputFinished();
		},
		[
			attachable.reducer,
			attachable.validation
		]
	);

	const licenses: readonly UserLicense[] = getNumericEnumValues(UserLicense);

	return (
		<UserLicenseList trackingId="user-license-list">
			{licenses.map((license): ReactElement => {
				const isSelected: boolean = attachable.value === license;

				return (
					<UserLicenseCard
						key={license}
						trackingId={generateTrackingId("user-license", `|${license}`)}
					>
						<UserLicenseCard.Header
							kind={license}
							status={isSelected ? "active" : "inactive"}
						/>

						<UserLicenseCard.Content>
							<UserLicenseDescription />
						</UserLicenseCard.Content>

						{hasFlag(editUserFieldsMode, EditableUserFields.UserLicense) && (
							<UserLicenseCard.FooterButton
								kind={isSelected ? "secondary" : "primary"}
								text={localize(isSelected ? "_Selected" : "_Select")}
								onClick={() => changeHandler(license)}
								isDisabled={isSelected}
							/>
						)}
					</UserLicenseCard>
				);
			})}
		</UserLicenseList>
	);
};
UserLicensesTab.displayName = "UserLicensesTab";
